import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {
    deletedProfessions,
    setProfessionalsData, setProfessionsRestoreData,
    updateProfessions
} from "./professionsSlice";


import {IErrorResponse, IRootState} from "../../../../types";
import {
    IEducationalProgram,
    IEducationProgramPayload, IGetProfessions,
    IProfessionChildProgramPayload,
    IProfessionCreate,
    IProfessionPayload
} from "../types";



const GetProfessions = createAsyncThunk<any, void | IGetProfessions>(
    "get/professions",
    async (_data, { dispatch, rejectWithValue,getState }) => {
        const data: IGetProfessions = _data || {};
        const search = data.searchQuery || {};
        const page = data.page || 0;
        const lang = getState()  as IRootState
        const defaultLanguage = lang.languages.defaultLanguage
        try {
            const response = await request.get("/professions", {
                params: {search, page },
            });
            const total = response.data.total;
            const currentPage = response.data.current_page;
            const perPage = response.data.per_page;

            dispatch(
                setProfessionalsData({
                    data: response.data.data,
                    totalPages: total,
                    currentPage,
                    pagesSize: perPage,
                    defaultLanguage
                })
            );


            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);





const CreateProfession = createAsyncThunk(
    "create/profession",
    async (data: IProfessionCreate, {rejectWithValue}) => {
        try {
            const response = await request.post("/professions", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const CreateProfessionDegree = createAsyncThunk(
    "create/profession/degree",
    async (data: IEducationProgramPayload, {rejectWithValue}) => {
        try {
            const response = await request.post("/educational-programs", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


const CreateChildProfession = createAsyncThunk(
    "create/child/profession",
    async (data: IProfessionChildProgramPayload, {rejectWithValue}) => {
        try {
            await request.post("/child-educational-programs", data);

        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


const DeleteProfessions = createAsyncThunk(
    "delete/professions",
    async (id: number, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.delete(`/professions/${id}`);
            dispatch(deletedProfessions(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const EditProfessions = createAsyncThunk(
    "edit/EditProfessions",
    async (data: IProfessionPayload, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.put(`/professions/${data.id}`, data);
            dispatch(updateProfessions(data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const EditEducationalPrograms = createAsyncThunk(
    "edit/educational/programs",
    async (data: IEducationalProgram, {rejectWithValue}) => {
        try {
            const response = await request.put(`/educational-programs/${data.id}`, data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const EditChildProfessions = createAsyncThunk(
    "edit/child/profession",
    async (data: IProfessionChildProgramPayload, {rejectWithValue}) => {
        try {
            const response = await request.put(`child-educational-programs/${data.id}`, data);
            return response.data
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
)


const DeleteEducationalPrograms = createAsyncThunk(
    "delete/educational/programs",
    async (id: number, {rejectWithValue}) => {
        try {
            const response = await request.delete(`/educational-programs/${id}`);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const DeleteChildProfession = createAsyncThunk(
    "delete/child/profession",
    async (id: number,{rejectWithValue}) => {
        try {
            const response = await request.delete(`child-educational-programs/${id}`);
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetDeletedProfession = createAsyncThunk(
    "get/deleted/profession",
    async (_, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.get(`/professions/deleted-items`);
            dispatch(setProfessionsRestoreData(response.data))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


const RestoreDeleteProfessions = createAsyncThunk(
    "restore/delete/professions",
    async (id: number,{rejectWithValue}) => {
        try {
            const response = await request.post(`/professions/restore/${id}`);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const RestoreDeleteProfessionsDegree = createAsyncThunk(
    "restore/delete/degree",
    async (id: number,{rejectWithValue}) => {
        try {
            const response = await request.post(`/educational-programs/restore/${id}`);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const RestoreDeleteProfessionsChild = createAsyncThunk(
    "restore/delete/child",
    async (id: number,{rejectWithValue}) => {
        try {
            const response = await request.post(`/child-educational-programs/restore/${id}`);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export {
    GetProfessions,
    EditEducationalPrograms,
    CreateProfession,
    DeleteProfessions,
    EditProfessions,
    CreateProfessionDegree,
    DeleteEducationalPrograms,
    CreateChildProfession,
    EditChildProfessions,
    DeleteChildProfession,
    GetDeletedProfession,
    RestoreDeleteProfessions,
    RestoreDeleteProfessionsDegree,
    RestoreDeleteProfessionsChild
}